<!-- <div echarts #SankeyChart [options]="chartOption" [merge]="mergeOptions" class="sankey-chart"></div> -->
<div echarts #SankeyChart [options]="chartOption" [merge]="mergeOptions" class="heatmap-chart"></div>
